import secureLocalStorage from "react-secure-storage";

export const STORAGE_KEYS = {
  token: "TOKEN",
  userData: "USER_DATA",
  credentials: "REMEBER_ME",
  tempToken: "TEMP_TOKEN",
  fcmToken: "FCM_TOKEN",
  rolePermission: "ROLE_PERMISSION",
};

export function storeData(key, value) {
  secureLocalStorage.setItem(key, value);
}
export function getData(key) {
  return secureLocalStorage.getItem(key);
}
export function clearData() {
  secureLocalStorage.clear();
}
export function removeData(key) {
  secureLocalStorage.removeItem(key);
}
